// Generated by scripts/generate-india-usa-sealanes.mjs — do not edit by hand. Snapshot: refresh weekly.
import type { SealanesServiceRecord, SealanesVesselRecord } from './sealanes-types';

export const SERVICE_CHUNKS: Record<string, () => Promise<SealanesServiceRecord[]>> = {
  "cma-cgm": () => import("./data/services/cma-cgm").then(m => m.SERVICES),
  "cosco": () => import("./data/services/cosco").then(m => m.SERVICES),
  "hapag-lloyd": () => import("./data/services/hapag-lloyd").then(m => m.SERVICES),
  "hmm": () => import("./data/services/hmm").then(m => m.SERVICES),
  "maersk": () => import("./data/services/maersk").then(m => m.SERVICES),
  "msc": () => import("./data/services/msc").then(m => m.SERVICES),
  "one": () => import("./data/services/one").then(m => m.SERVICES),
  "oocl": () => import("./data/services/oocl").then(m => m.SERVICES),
  "wan-hai": () => import("./data/services/wan-hai").then(m => m.SERVICES),
  "zim": () => import("./data/services/zim").then(m => m.SERVICES),
};

export const VESSEL_CHUNKS: Record<string, () => Promise<SealanesVesselRecord[]>> = {
  "a": () => import("./data/vessels/a").then(m => m.VESSELS),
  "b": () => import("./data/vessels/b").then(m => m.VESSELS),
  "c": () => import("./data/vessels/c").then(m => m.VESSELS),
  "e": () => import("./data/vessels/e").then(m => m.VESSELS),
  "h": () => import("./data/vessels/h").then(m => m.VESSELS),
  "i": () => import("./data/vessels/i").then(m => m.VESSELS),
  "k": () => import("./data/vessels/k").then(m => m.VESSELS),
  "m": () => import("./data/vessels/m").then(m => m.VESSELS),
  "n": () => import("./data/vessels/n").then(m => m.VESSELS),
  "o": () => import("./data/vessels/o").then(m => m.VESSELS),
  "r": () => import("./data/vessels/r").then(m => m.VESSELS),
  "s": () => import("./data/vessels/s").then(m => m.VESSELS),
  "t": () => import("./data/vessels/t").then(m => m.VESSELS),
  "w": () => import("./data/vessels/w").then(m => m.VESSELS),
  "x": () => import("./data/vessels/x").then(m => m.VESSELS),
  "z": () => import("./data/vessels/z").then(m => m.VESSELS),
};

/** Which chunk holds a vessel page. */
export const vesselChunk = (slug: string) => (/^[a-z]/.test(slug) ? slug[0] : '0');
